<template>
    <table-actions-menu
        position="table-action-menu--low"
        width="table-action-menu--only-two"
    >
        <edit-button :url="route('main.courses.variations.edit', {'course': data.course_id, 'variation': data.id})" grid="table-action-cell--grid-1of2"></edit-button>

        <delete-button
            :url="route('mainapi.courses.variations.destroy', {'course': data.course_id, 'variation': data.id})"
            :confirmTitle="this.trans('course_variations.note.delete_title')"
            :confirmText="this.trans('course_variations.note.delete_message')"
            :deleteId="data.id"
            grid="table-action-cell--grid-1of2"
        ></delete-button>
    </table-actions-menu>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'

    export default {
        props: ['data', 'index'],

        components: {
            InlineSvg
        }
    }
</script>
